export function formatIBAN(IBAN?: string) {
  // Ensure IBAN is a string
  if (!IBAN || typeof IBAN !== "string") {
    return "";
  }

  // Only format IBANs that are at least 8 characters (to avoid incorrect spacing on short values)
  // Typical IBAN format: IR (2 chars) + check digits (2 chars) + bank code (3 chars) + account number
  if (IBAN.length < 8) {
    return IBAN;
  }

  const result = IBAN.split("")
    .map((char, index) => ([2, 4, 7].includes(index) || (index > 7 && (index - 7) % 4 === 0) ? ` ${char}` : char))
    .join("");

  return result;
}
